import { sagas as feedSagas } from './modules/feed'

export default [...feedSagas]
